import { useSelector } from 'react-redux';
// import CircularProgress from '@mui/material/CircularProgress';
import { StyledLoader, StyledLoaderWrap } from './StyledLoader';
import { selectorLoader } from '../../../store/reducers/loader';
import ShimmerLoader from './ShimmerLoader';

export default function Loader() {
  const { isLoading } = useSelector(selectorLoader);

  return (
    <StyledLoaderWrap className={isLoading ? 'loader_block' : 'loader_block hide-display'}>
      <StyledLoader>
        {/* <CircularProgress disableShrink={!isLoading} /> */}
        <ShimmerLoader />
      </StyledLoader>
    </StyledLoaderWrap>
  );
}
